import { render } from "./PostSearchLoader.vue?vue&type=template&id=44d9fa1e&ts=true"
import script from "./PostSearchLoader.vue?vue&type=script&lang=ts"
export * from "./PostSearchLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__